export enum CurrencyCode {
  USD = 'USD',
  ARS = 'ARS',
}
